module.exports = __webpack_public_path__ + "img/avatar-67.e6fa21b2.png";